import * as Sentry from '@sentry/browser'

export default function initSentry() {
  const railsEnv = document.querySelector('meta[name="rails-env"]')?.getAttribute('content');

  if (railsEnv === 'production' || railsEnv === 'staging') {
    Sentry.init({
      environment: railsEnv,
      dsn: 'https://7c2a37139f2d4be9bc384784b0f824d1@o579424.ingest.sentry.io/5494950',
      sendDefaultPii: true,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      enableLogs: true,
      tracesSampleRate: 0.3,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
}
